// Hide DynamicModal when dropdown selection done.
compiler('#api_product_type_select', (element) => {
  const items = document.querySelectorAll('#api_product_type_select a');
  const modal = bootstrap.Modal.getInstance(document.querySelector('.dynamic-modal'));
  items.forEach((dropdown_item) => {
    dropdown_item.addEventListener('click', (e) => {
      modal.hide();
    });
  });
})
